import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=77042010&"
import script from "./NewFooter.vue?vue&type=script&lang=js&"
export * from "./NewFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports